'use client';

import { useEffect } from 'react';

import { branchesListId } from '@/app/(main)/(pages)/_components/branches-section/consts/branches-section.const';

export const BranchesSectionScrollHandler = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (window.location.hash === `#${branchesListId}`) {
      const section = document.getElementById(branchesListId);

      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    }
  }, []);

  return null;
};
